@use "../../../../../../../../styles/Colors.scss" as Colors;
@use "../../../../../../../../styles/Constants.scss" as Constants;

.MaterialGroups {
	margin-top: Constants.$val-spacing-m;
}

.MaterialGroupInput {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	
	.input {
		flex: 1;
	}

	.removeControl {
		padding: Constants.$val-spacing-s;
	}
}
